module.exports = __webpack_public_path__ + "bin/22104fa6e26df6fc367b91eea2b4fff3.png";